import axios from 'axios';

export function get({ url, data: params, accessToken, headers = {} }) {
  if (accessToken) {
    Object.assign({
      Authorization: `Bearer ${accessToken}`,
    }, headers,
    );
  }

  const request = axios.get(url, {
    params,
    headers,
  });

  return request;
}

export function post({ url, data, accessToken, headers = {} }) {
  if (accessToken) {
    Object.assign({
      Authorization: `Bearer ${accessToken}`,
    }, headers,
    );
  }

  const request = axios.post(url, data, { headers });

  return request;
}

export function put({ url, data, accessToken, headers = {} }) {
  if (accessToken) {
    Object.assign({
      Authorization: `Bearer ${accessToken}`,
    }, headers,
    );
  }

  const request = axios.put(url, data, { headers });

  return request;
}

export function del({ url, data: params, accessToken, headers = {} }) {
  if (accessToken) {
    Object.assign({
      Authorization: `Bearer ${accessToken}`,
    }, headers,
    );
  }

  const request = axios.delete(url, {
    params,
    headers,
  });

  return request;
}
